export default "__VITE_ASSET__BGqhAmL3__";